<div class="policy bg-light">

    <div class="policy__container" [style.height.px]="appAlert.windowHeight - 200">
        <div class="policy_header">
            <h1>{{subtitles.setSubtitle(12665).toUpperCase()}}</h1>
        </div>

        <div class="policy_paragraph">
            <p class="policy_paragraph__content">
                {{subtitles.setSubtitle(8249)}}
            </p>
        </div>
    </div>

    <div class="policy__buttons-box">
        <input type="button"
               [value]="subtitles.setSubtitle(1744)"
               class="app-alert__button  bg-ok color-light font-bold font-14 cursor-pointer"
               (click)="appAlert.closePolicy()">
    </div>
</div>

